type Transaction = {
  title: string;
  time: string;
  points: string;
};

type RewardsPreviewCardProps = {
  transactions: Transaction[];
};

export const RewardsPreviewCard = ({
  transactions,
}: RewardsPreviewCardProps) => {
  return (
    <div>
      <div className="hidden lg:block">
       <div
      className="
        relative overflow-hidden
        rounded-[30px]
        bg-[linear-gradient(90deg,#990000_0%,#CD0000_34%,#990000_100%)]
        min-h-[470px]
        px-10 pt-10 pb-10
      "
    >
      <img
        src="/images/Webp/layer-1.webp"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-95 pointer-events-none"
        aria-hidden="true"
      />

      <div className="absolute right-[32px] top-[32px] z-10">
        <img
          src="/images/star-2.svg"
          alt=""
          className="w-[76px] h-[76px]"
          aria-hidden="true"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-black">
          <span className="text-[12px] leading-none">Earn</span>
          <span className="text-[22px] leading-none font-semibold mt-1">2X</span>
          <span className="text-[12px] leading-none mt-1">Points</span>
        </div>
      </div>

      <div className="relative z-10 flex items-start gap-5">
        <div
          className="
            w-[72px] h-[72px]
            rounded-[20px]
            border-[3px] border-[#FF0000]
            bg-white
            flex items-center justify-center
            shrink-0
          "
        >
          <img
            src="/images/image-19.png"
            alt="Rewards trophy"
            className="w-[44px] h-[44px] object-contain"
          />
        </div>

        <div>
          <h3 className="text-white text-[24px] md:text-[26px] font-medium leading-[1.1]">
            2,450 pts
          </h3>
          <p className="mt-2 text-white text-[16px] md:text-[18px] leading-[1.3]">
            Total earned this month
          </p>
        </div>
      </div>

      <div className="relative z-10 mt-10 space-y-4">
        {transactions.map((transaction, index) => (
          <div
            key={index}
            className="
              rounded-[24px]
              border-2 border-white/90
              bg-[linear-gradient(135deg,rgba(245,230,230,0.40)_0%,rgba(245,230,230,0.30)_100%)]
              backdrop-blur-[8px]
              shadow-[0px_0px_38px_rgba(191,0,0,0.08)]
              px-8 py-5
              flex items-center justify-between gap-6
            "
          >
            <div>
              <h4 className="text-white text-[24px] leading-[1.2] font-medium">
                {transaction.title}
              </h4>
              <p className="mt-2 text-white text-[18px] leading-[1.2]">
                {transaction.time}
              </p>
            </div>

            <div className="text-white text-[40px] md:text-[44px] font-medium leading-none whitespace-nowrap">
              {transaction.points}
            </div>
          </div>
        ))}
      </div>
    </div>
      </div>

      <div className="block lg:hidden">
       <div
      className="
        relative overflow-hidden
        rounded-[30px]
        bg-[linear-gradient(90deg,#990000_0%,#CD0000_34%,#990000_100%)]
        
        px-6 py-8
      "
    >
      <img
        src="/images/Webp/layer-1.webp"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-95 pointer-events-none"
        aria-hidden="true"
      />

      <div className="absolute right-[22px] top-[22px] z-10">
        <img
          src="/images/star-2.svg"
          alt=""
          className="w-[72px] h-[72px]"
          aria-hidden="true"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-black">
          <span className="text-[10px] leading-none">Earn</span>
          <span className="text-[16px] leading-none font-semibold mt-1">2X</span>
          <span className="text-[10px] leading-none mt-1">Points</span>
        </div>
      </div>

      <div className="relative z-10 flex items-center gap-3 mt-2">
        <div
          className="
            w-[42px] h-[42px]
            rounded-[10px]
            border-2 border-solid border-red-600
            bg-white
            flex items-center justify-center
            shrink-0
          "
        >
          <img
            src="/images/image-19.png"
            alt="Rewards trophy"
            className="w-[30px] h-[30px] object-contain"
          />
        </div>

        <div>
          <h3 className="text-white text-[14px] md:text-[26px] font-medium leading-[1.1]">
            2,450 pts
          </h3>
          <p className="mt-1 text-white text-[12px] md:text-[18px] leading-[1.3]">
            Total earned this month
          </p>
        </div>
      </div>

      <div className="relative z-10 mt-10 space-y-4">
        {transactions.map((transaction, index) => (
          <div
            key={index}
            className="
              rounded-[20px]
              border-2 border-solid border-white
              bg-[linear-gradient(135deg,rgba(245,230,230,0.40)_0%,rgba(245,230,230,0.30)_100%)]
              backdrop-blur-[8px]
              shadow-[0px_0px_38px_rgba(191,0,0,0.08)]
              px-6 py-4
              flex items-center justify-between gap-6
            "
          >
            <div>
              <h4 className="text-white text-[16px] leading-[1.2] font-medium">
                {transaction.title}
              </h4>
              <p className="mt-1 text-white text-[12px] leading-[1.2]">
                {transaction.time}
              </p>
            </div>

            <div className="text-white text-[28px] md:text-[44px] font-medium leading-none whitespace-nowrap">
              {transaction.points}
            </div>
          </div>
        ))}
      </div>
    </div>
      </div>
    </div>
   
  );
};